export default "__VITE_ASSET__CgJpRmBS__"